import * as React from "react";

import { PatternFormat, PatternFormatProps } from "react-number-format";
import TextField from "@mui/material/TextField";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  name: string;
  format: string;
}

interface MaskInputProps {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: boolean;
  errorText?: string;
  value: string;
  name: string;
  format: string;
  label: string;
  disabled: boolean;
}

const NumericFormatCustom = React.forwardRef<PatternFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, format, name, handleBlur, ...other } = props;

    return (
      <PatternFormat
        {...other}
        onBlur={handleBlur}
        name={name}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        format={format}
        valueIsNumericString
      />
    );
  }
);

const MaskedInput: React.FC<MaskInputProps> = ({
  handleChange,
  handleBlur,
  value,
  name,
  format,
  label,
  error,
  errorText,
  disabled,
}) => {
  return (
    <TextField
      required
      variant="outlined"
      error={error}
      label={label}
      value={value}
      onChange={handleChange}
      name={name}
      helperText={error && errorText}
      disabled={disabled}
      id="formatted-numberformat-input"
      InputProps={{
        inputComponent: NumericFormatCustom as any,
        inputProps: { format, handleBlur },
      }}
    />
  );
};

export default MaskedInput;
